import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCheckmarkStyle0 = cosmosIconCss;

const CosmosIconCheckmark = /*@__PURE__*/ proxyCustomElement(class CosmosIconCheckmark extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M8.13 17.14a.499.499 0 0 1-.369-.127L3.298 13a.5.5 0 0 1-.037-.706l.334-.372a.5.5 0 0 1 .706-.038l3.74 3.364 9.597-10.232a.5.5 0 0 1 .707-.023l.365.342a.5.5 0 0 1 .022.707L8.472 16.983a.499.499 0 0 1-.341.158", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCheckmarkStyle0; }
}, [1, "cosmos-icon-checkmark", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-checkmark"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-checkmark":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCheckmark);
            }
            break;
    } });
}

export { CosmosIconCheckmark as C, defineCustomElement as d };
